import Companies from "assets/navigationIcons/companies.svg?react";
import CreditLimitRequest from "assets/navigationIcons/creditLimitRequests.svg?react";
import DashboardIcon from "assets/navigationIcons/dashboard.svg?react";

import {
  AGENT_DASHBOARD,
  // AGENT_CREDIT_LIMITS_LINK,
  AGENT_TERMSHEETS,
  AGENT_LEADS,
} from "codes";
export const AGENT_USER = (t: Function, styling: object) => [
  {
    title: t("Dashboard"),
    icon: DashboardIcon,
    ...styling,
    link: AGENT_DASHBOARD,
  },
  // {
  //   title: "Credit Limits",
  //   icon: CreditLimitRequest,
  //   ...styling,
  //   link: AGENT_CREDIT_LIMITS_LINK,
  // },
  {
    title: "Termsheets",
    icon: Companies,
    ...styling,
    link: AGENT_TERMSHEETS,
  },
  {
    title: "Leads",
    icon: CreditLimitRequest,
    ...styling,
    link: AGENT_LEADS,
  },
];
